import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

export default class DocumentComponent extends Component {
  init() {
    this.element.setAttribute('hidden', 'hidden')
    window.addEventListener('fetch-data', event => this.onFetchData(event))
  }

  onFetchData(event) {
    if (!event.detail) {
      return
    }

    this.element.removeAttribute('hidden')
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'document', DocumentComponent))
